<template>
  <div class="homePage">
    <!-- <div class="homebg">
      <img src="../assets/home/coupons_bg.png" alt />
    </div>-->
    <div class="bigBg">
      <div class="publicBox">
        <div class="yellowArticle">
          <img src="../assets/home/ic_yellow.png" alt />
        </div>
        <div class="publicWhiteBox">
          <div class="publicTitleBox box_c">
            <img src="../assets/home/title_left.png" alt />
            <span>新人启航大礼包</span>
            <img src="../assets/home/title_right.png" alt />
          </div>
          <div v-if="!getCouponTrue">
            <div class="couponList" v-for="(item,index) in tickets" :key="index">
              <img src="../assets/home/ticket1_bg.png" alt class="couponBgImg" />
              <div class="couponView box">
                <div class="couponLeft box_c" v-if="item.type==1">
                  <div class="couponNumBox">
                    ¥
                    <span>{{item.money}}</span>
                  </div>
                </div>
                <div class="couponLeft box_c" v-else-if="item.type==2">
                  <div class="couponNumBox">
                    <span>{{item.money}}</span>天
                  </div>
                </div>
                <div class="couponLeft box_c" v-else-if="item.type==3">
                  <div class="couponNumBox">
                    <span>{{Number(item.money)*10}}</span>折
                  </div>
                </div>
                <div class="couponRight box_h">
                  <div>
                    <div class="couponName">{{item.title}}</div>
                    <div class="couponCondition">{{item.describe}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="couponHint txt">优惠券领取日开始半年内有效，请及时使用</div>
            <div class="getCouponBox">
              <div class="getBtn box_c" v-if="!hasCoupon" @click="getCoupon">
                <span>立即领取</span>
              </div>
              <div class="notGetBtn box_c" v-else>已领取</div>
            </div>
          </div>

          <div class="hasCouponBox txt" v-else>
            <img src="../assets/register/coupon_ic_success.png" alt />
            <div class="successVlaue">恭喜您，领券成功！</div>
            <div class="successHint">优惠券已放入您的账户，请前往飞游无人机小程序使用</div>
          </div>
        </div>
      </div>
      <div class="publicBox">
        <div class="yellowArticle">
          <img src="../assets/home/ic_yellow.png" alt />
        </div>
        <div class="publicWhiteBox">
          <div class="publicTitleBox box_c">
            <img src="../assets/home/title_left.png" alt />
            <span>推荐</span>
            <img src="../assets/home/title_right.png" alt />
          </div>
          <div class="bannerBox">
            <!-- <van-swipe
              class="my-swipe"
              :autoplay="2000"
              indicator-color="white"
              :show-indicators="false"
            >
              <van-swipe-item v-for="(item,index) in bannerList" :key="index">
                <div class="imgList">
                  <img :src="item.img" alt />
                  <div class="name txt">{{item.desc}}</div>
                </div>
              </van-swipe-item>
            </van-swipe>-->
            <carousel-3d
              :autoplay="true"
              @after-slide-change="change"
              :display="3"
              :border="0"
              :width="200"
              :height="115"
              :autoplayTimeout="2000"
            >
              <slide v-for="(item,index) in bannerList" :key="index" :index="index">
                <div class="imgList">
                  <img :src="item.img" alt />
                </div>
              </slide>
            </carousel-3d>
            <div class="desc txt">{{bannerList[slideIndex].desc}}</div>
          </div>
          <div class="recBox">
            <div class="recList box_qh" v-for="(item,index) in leaseData" :key="index">
              <div class="listImg box_c">
                <img :src="item.img" />
              </div>
              <div class="listInfo">
                <div class="listName">{{item.name}}</div>
                <div class="sales"></div>
                <div class="listBottom box_cqh">
                  <div class="listPrice">
                    ¥{{item.rent_price}}
                    <span class="small">/天起</span>
                  </div>
                  <!-- <div class="leaseBtn box_c" @click="goMini(item.id)">立即租赁</div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swipe, SwipeItem, Toast } from "vant";
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import { Carousel3d, Slide } from "vue-carousel-3d";
import "swiper/css/swiper.css";
import qs from "qs";
// var vConsole = new VConsole();
let isAli = "";
export default {
  components: {
    Swiper,
    SwiperSlide,
    Carousel3d,
    Slide,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      hasCoupon: false, //是否已经领取优惠券
      miniProgram: false,
      getCouponTrue: false, //是否领取成功
      token: "",
      tickets: [], //优惠券列表
      isRequest: true,
      slideIndex: 0,
      leaseData: [
        {
          deposit: "3299.00",
          id: 1,
          num: 123,
          img: require("../assets/home/coupons_goods_mini.png"),
          name: "DJI 大疆 御 Mavic Mini 航拍便携可折叠无人机",
          rent_price: "9.90",
        },
        {
          deposit: "6299.00",
          id: 2,
          num: 109,
          img: require("../assets/home/coupons_goods_air2.png"),
          name: "DJI 大疆 御 Mavic AIR2 4K高清可折叠航拍无人机",
          rent_price: "29.90",
        },
      ],
      bannerList: [
        {
          deposit: "3299.00",
          id: 1,
          num: 123,
          img: require("../assets/home2/home_pic1.png"),
          name: "DJI 大疆 御 Mavic Mini 航拍便携可折叠无人机",
          rent_price: "9.90",
          desc: "MAVIC MINI拍摄",
        },
        {
          deposit: "6299.00",
          id: 2,
          num: 109,
          img: require("../assets/home2/home_pic2.png"),
          name: "DJI 大疆 御 Mavic AIR2 4K高清可折叠航拍无人机",
          rent_price: "29.90",
          desc: "MAVIC AIR2拍摄",
        },
        {
          deposit: "3299.00",
          id: 1,
          num: 123,
          img: require("../assets/home2/home_pic3.png"),
          name: "DJI 大疆 御 Mavic Mini 航拍便携可折叠无人机",
          rent_price: "9.90",
          desc: "MAVIC MINI拍摄",
        },
      ],
      swiperOptions: {
        autoplay: true,
        loop: true,
        effect: "coverflow",
        slidesPerView: 2,
        centeredSlides: true,
        coverflowEffect: {
          rotate: 20,
          stretch: 10,
          depth: 80,
          modifier: 1,
          slideShadows: true,
        },
        // Some Swiper option/callback...
      },
    };
  },
  computed: {},
  methods: {
    couponStatus() {
      this.$get("user_ticket/index").then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this.hasCoupon = res.data.status;
          this.tickets = res.data.tickets;
        } else if (res.code == 401 && this.miniProgram) {
          if (isAli) {
            my.switchTab({
              url: "/pages/user/user",
            });
          } else {
            uni.switchTab({
              url: "/pages/user/user",
            });
          }

          // Toast(res.msg);
        } else {
          // Toast(res.msg);
        }
      });
    },
    getCoupon() {
      var u = navigator.userAgent;
      // 安卓
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
      // IOS
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isAndroid || isiOS) {
        console.log("app环境");
      } 
      if (this.isRequest) {
        this.isRequest = false;
        let data = {
          type: 1,
        };
        if ((isAndroid || isiOS || this.miniProgram) && this.token) {
          Toast.loading({
            message: "请稍后...",
            forbidClick: true,
          });
          this.$post("ticket/user", qs.stringify(data))
            .then((res) => {
              Toast.clear();
              // console.log(res);
              this.isRequest = true;
              if (res.code == 200) {
                this.getCouponTrue = true;
              } else if (res.code == 401) {
                Toast({
                  message: res.msg,
                  duration: 1500,
                });
                setTimeout(() => {
                  if (isAli) {
                    my.switchTab({
                      url: "/pages/user/user",
                    });
                  } else {
                    uni.switchTab({
                      url: "/pages/user/user",
                    });
                  }
                }, 1500);
              } else {
                Toast(res.msg);
              }
            })
            .catch((err) => {
              console.log(err);
              Toast.clear();
              Toast("登录状态过期，请退出账号重新登录");
              setTimeout(() => {
                if (isAli) {
                  my.switchTab({
                    url: "/pages/user/user",
                  });
                } else {
                  uni.switchTab({
                    url: "/pages/user/user",
                  });
                }
              }, 1500);
              this.isRequest = true;
            });
        } else if (this.miniProgram && (!this.token || this.token == "")) {
          Toast({
            message: "您还没有登录",
            duration: 1500,
          });
          setTimeout(() => {
            if (isAli) {
              my.switchTab({
                url: "/pages/user/user",
              });
            } else {
              uni.switchTab({
                url: "/pages/user/user",
              });
            }
          }, 1500);
        } else {
          this.$router.push("/register");
        }
      } else {
        Toast("搞慢点~");
      }
    },
    onSwiperSlideChangeTransitionStart() {
      console.log(index);
    },
    goMini(id) {
      if (this.miniProgram) {
        if (isAli) {
          my.navigateTo({ url: "/pages/goods/goods?id=" + id });
        } else {
          uni.navigateTo({ url: "/pages/goods/goods?id=" + id });
        }
      } else {
        /*判断当前环境是Android还是iOS*/
        var u = navigator.userAgent;
        // 安卓
        var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
        // IOS
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isAndroid || isiOS) {
          console.log("app环境");
          window.location.href =
            "http://tweb.feiyouyun.com/h5/#/pages/goods/goods?id=" + id;
        } else {
          Toast("请前往飞游无人机小程序租赁");
        }
      }
    },
    initWxapi() {
      this.$get("wechat/share?url=" + window.location.href).then((res) => {
        console.log(res);
      });
    },
    change(index) {
      // console.log(index)
      this.slideIndex = index;
    },
  },
  mounted() {
    let that = this;
    // 引入微信分享封装函数
    that.wxApi.wxRegister();
    that.token = that.$route.query.token;
    window.localStorage.setItem("token", that.token);
    that.couponStatus();
    var userAgent = navigator.userAgent;
    if (userAgent.indexOf("AlipayClient") > -1) {
      isAli = true;
    } else {
      isAli = false;
    }
    console.log(isAli);
    if (isAli) {
      my.getEnv(function (res) {
        console.log(res);
        if (res.miniprogram) {
          that.miniProgram = true;
          if (that.token) {
            that.couponStatus();
          }
        }
      });
    } else {
      document.addEventListener("UniAppJSBridgeReady", function () {
        uni.getEnv(function (res) {
          console.log(res);
          console.log("当前环境：" + JSON.stringify(res));
          if (res.miniprogram) {
            that.miniProgram = true;
            if (that.token) {
              that.couponStatus();
            }
          }
        });
      });
    }

    // wx.miniProgram.getEnv(function(res) {
    //   if (res.miniprogram) {
    //     console.log("mini");
    //     that.miniProgram = true;

    //     // 走在小程序的逻辑
    //   } else {
    //     console.log("h5");
    //     // 走不在小程序的逻辑
    //   }
    // });
  },
};
</script>

<style scoped lang='scss'>
@import "../common/font/font.css";
.homePage {
  width: 100%;
  min-height: 100vh;
  overflow-y: auto;
  padding-top: 170px;
  background: url("../assets/home/coupons_bg.png") no-repeat;
  background-size: 100%;
  background-color: #f64841;
  .swiper-container {
    width: 100%;
    height: 115px;
  }
  .homebg {
    width: 100%;
    img {
      width: 100%;
    }
  }
  .bigBg {
    position: relative;
    // top: -87px;
  }
  .publicBox {
    width: 100%;
    padding: 0 11px;
    box-sizing: border-box;
    // margin-bottom: 20px;
    .yellowArticle {
      width: 100%;
      img {
        width: 100%;
      }
    }
    .publicWhiteBox {
      width: calc(100% - 12px);
      margin: 0 auto;
      background: rgba(255, 255, 255, 1);
      border-radius: 5px;
      padding: 18px 15px;
      box-sizing: border-box;
      position: relative;
      top: -30px;
      .publicTitleBox {
        width: 100%;
        font-size: 20px;
        font-family: Alibaba PuHuiTi;
        font-weight: bold;
        color: rgba(254, 36, 47, 1);
        margin-bottom: 25px;
        span {
          margin: 0 5px;
        }
        img {
          width: 14px;
        }
      }
      .couponList {
        width: 100%;
        position: relative;
        .couponBgImg {
          width: 100%;
        }
        .couponView {
          width: 100%;
          height: 100%;
          position: absolute;
          top: -7px;
          left: 0;
          .couponLeft {
            flex: 3;
            height: 100%;
            color: #ffffff;
            font-size: 12px;
            font-family: PingFang SC;
            padding-left: 10px;
            box-sizing: border-box;
            .couponNumBox {
              vertical-align: baseline;
            }
            span {
              font-size: 50px;
              // font-weight: bold;
              font-family: "number";
              // margin: 0 2px;
            }
          }
          .couponRight {
            flex: 7;
            height: 100%;
            padding-left: 20px;
            box-sizing: border-box;
            .couponName {
              font-size: 18px;
              font-family: PingFang SC;
              font-weight: bold;
              color: rgba(255, 255, 255, 1);
              margin-bottom: 10px;
            }
            .couponCondition {
              font-size: 12px;
              font-family: PingFang SC;
              // font-weight: 500;
              color: rgba(255, 255, 255, 1);
              text-align: left;
            }
          }
        }
      }
      .getCouponBox {
        width: 144px;
        height: 45px;
        margin: 10px auto;
        .getBtn {
          width: 100%;
          height: 100%;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
          background: url("../assets/home/btn_receive.png") no-repeat;
          background-size: 100%;
          padding-bottom: 10px;
          box-sizing: border-box;
        }
        .notGetBtn {
          width: 100%;
          height: 100%;
          background-color: #c6c6c6;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
          background: url("../assets/home/btn_received.png") no-repeat;
          background-size: 100%;
        }
      }
      .hasCouponBox {
        width: 100%;
        img {
          width: 87px;
          margin-bottom: 15px;
        }
        .successVlaue {
          font-size: 15px;
          font-family: PingFang SC;
          font-weight: bold;
          color: rgba(254, 36, 47, 1);
          margin-bottom: 20px;
        }
        .successHint {
          font-size: 11px;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
        }
      }
      .couponHint {
        font-size: 13px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        margin-top: 15px;
      }
    }
    .bannerBox {
      width: 100%;
      margin-bottom: 15px;
      .imgList {
        // margin: 0 auto;
        // width: 80%;
        // height: 135px;
        img {
          width: 100%;
          // border-radius: 5px;
          // height: 100%;
          // object-fit: cover;
        }
      }
      .desc {
        width: 100%;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(153, 153, 153, 1);
      }
    }
    /* 租赁推荐 */
    .recBox {
      width: 100%;
    }
    .recList {
      width: 100%;
      margin-bottom: 14px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 3px 3px 0px rgba(172, 172, 172, 0.35);
      border-radius: 5px;
    }
    .listImg {
      width: 130px;
      height: 130px;
      background: rgba(243, 243, 243, 1);
      border-radius: 4px;
    }
    .listImg img {
      width: 100%;
    }
    .listInfo {
      width: 209px;
      height: 100%;
      padding: 16px 10px;
      box-sizing: border-box;
      padding-bottom: 0px;
    }
    .listName {
      font-size: 14px;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      line-height: 18px;
      min-height: 36px;
      margin-bottom: 35px;
    }
    .sales {
      font-size: 11px;
      font-weight: bold;
      color: rgba(153, 153, 153, 1);
    }
    .listPrice {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(255, 51, 51, 1);
      line-height: 17px;
    }
    .small {
      font-size: 13px;
      line-height: 13px;
    }
    .leaseBtn {
      width: 76px;
      height: 28px;
      background: rgba(255, 51, 51, 0.15);
      border-radius: 14px;
      font-size: 13px;
      font-weight: bold;
      color: rgba(255, 51, 61, 1);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/home.vue